


































































































import G_020_JuchuEntry_ChildActionsBtn from '@/components/G_kaigai/G_020_JuchuEntry_ChildActionsBtn.vue';
import { Color, ShoriKb, UmuFlg, MukoKb } from '@/constants/constants';
import { isShorikbREFER } from '@/utils/utils';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_020_JuchuEntry_ChildHeaderInput_Table',
  components: {
    G_020_JuchuEntry_ChildActionsBtn,
  },
  props: {
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    tankaHyojiKb: {
      type: Number,
      default: UmuFlg.ARI,
    },
    hasuHyojiKb: {
      type: Number,
      default: UmuFlg.ARI,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    ShoriKb,
    Color,
    UmuFlg,
    MukoKb,
    headers: [
      {
        text: '№',
        value: 'numberOrder',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 50,
      },
      {
        text: '品目',
        value: 'himmoku',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: false,
        width: 410,
      },
      {
        text: '単位',
        value: 'tani',
        sortable: false,
        width: 60,
      },
      {
        text: '入数',
        value: 'irisu',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 60,
      },
      {
        text: 'c/s数量',
        value: 'juchuSuryo',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 75,
      },
      {
        text: 'バラ数量',
        value: 'hasuSuryo',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 85,
      },
      {
        text: '重量',
        value: 'juchuJuryo',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 110,
      },
      {
        text: '金額',
        value: 'juchuZeinukiKingaku',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 95,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        width: 30,
      },
    ],
  }),
  computed: {
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
  },
});
